import {FormattedMessage} from "react-intl";
import * as React from "react";
import {ReactElement, ReactNode} from "react";

export type FormLabelType = ReactElement<FormattedMessage> | string;

export default function FormLabelRenderer(label: FormLabelType, renderFunc: (text: string) => ReactNode): ReactNode {
    if(typeof label === 'string') {
        return renderFunc(label);
    } else {
        return React.cloneElement(label as ReactElement<any>, {
            children: renderFunc
        })
    }
}